import { Injectable } from '@angular/core';
import {
	CachePolicy,
	CachePolicyEntity,
	UrlService,
} from '@datachain/ui-sdk/common';
import { Observable } from 'rxjs';

import { DcBaseRequester } from '../core/dc-base.requester';
import { IDatablockResponse } from './datablock.model';
import { IDatablock } from './datablock.model';

@Injectable({
	providedIn: 'root',
})
export class DatablockRequester extends DcBaseRequester<IDatablockResponse> {
	protected resource;
	protected elementsListUrl;
	protected singleElementUrl;
	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = this.generateResourceUrl('DATABLOCKS_DETAILED');
		this.elementsListUrl = this.resource;
		this.singleElementUrl = this.resource;
	}

	public getDatablockList(
		includePublic: boolean,
		useCache: boolean
	): Observable<ReadonlyArray<IDatablockResponse>> {
		const url = this.urlService.generateUrl(
			this.resource,
			{},
			{
				project: this.projectId,
				excludePublic: !includePublic,
			}
		);
		const cachePolicy = useCache
			? CachePolicyEntity.build({
					policy: CachePolicy.NetworkAndCache,
					evictTimeoutInSeconds: 60,
					isCacheable: true,
			  })
			: CachePolicyEntity.build({
					policy: CachePolicy.NetworkOnly,
					evictTimeoutInSeconds: 0,
					isCacheable: false,
			  });
		return this.get<Array<IDatablockResponse>>(url, cachePolicy);
	}

	public deleteDatablock(datablockId: number): Observable<void> {
		const resourceUrl = this.generateResourceUrl('DATABLOCK');
		const url = this.urlService.generateUrl(
			resourceUrl,
			{
				datablockId,
			},
			{
				project: this.projectId,
			}
		);
		return this.http.delete<void>(url);
	}
	public deleteMany(datablockIds: Array<number>): Observable<void> {
		const resourceUrl = this.generateResourceUrl('DATABLOCKS');
		const url = this.urlService.generateUrl(
			resourceUrl,
			{},
			{
				project: this.projectId,
				datablockIds,
			}
		);
		return this.http.delete<void>(url);
	}

	public getDatablock(datablockId: number): Observable<IDatablock> {
		const resourceUrl = this.generateResourceUrl('DATABLOCK');
		const url = this.urlService.generateUrl(
			resourceUrl,
			{
				datablockId,
			},
			{
				project: this.projectId,
			}
		);
		return this.http.get<IDatablock>(url);
	}

	public updateDatablock(datablock: IDatablock): Observable<void> {
		const resourceUrl = this.generateResourceUrl('DATABLOCKS');
		const url = this.urlService.generateUrl(
			resourceUrl,
			{},
			{
				project: this.projectId,
			}
		);
		return this.http.put<void>(url, datablock);
	}

	public stopPersistence(jobId: string): Observable<void> {
		const resourceUrl = this.generateResourceUrl('SPARK_JOB');
		const url = this.urlService.generateUrl(
			resourceUrl,
			{
				jobKey: jobId,
			},
			{
				project: this.projectId,
			}
		);
		return this.http.delete<void>(url);
	}
}
